import { Show, JSX } from 'solid-js'

type PageHeroProps = {
  badge?: string
  title: string | JSX.Element
  subtitle?: string
  children?: JSX.Element
}

export function PageHero(props: PageHeroProps) {
  return (
    <div class="relative overflow-hidden pt-12 pb-8 text-center">
      {/* Glow backgrounds */}
      <div
        class="pointer-events-none absolute left-1/2 top-0 -translate-x-1/2"
        style={{
          width: '600px',
          height: '300px',
          background: 'radial-gradient(ellipse at center, rgba(138,43,226,0.12) 0%, transparent 70%)',
        }}
      />
      <div
        class="pointer-events-none absolute right-0 top-1/4"
        style={{
          width: '400px',
          height: '400px',
          background: 'radial-gradient(circle, rgba(0,229,255,0.06) 0%, transparent 70%)',
        }}
      />

      <div class="relative z-10">
        <Show when={props.badge}>
          <div class="cf-eyebrow pill mb-3.5 inline-flex">
            <span
              class="inline-block h-[6px] w-[6px] rounded-full"
              style={{ background: 'var(--cf-cyan)', 'box-shadow': '0 0 8px var(--cf-cyan)' }}
            />
            {props.badge}
          </div>
        </Show>
        <h1 class="cf-h1 mb-3.5">{props.title}</h1>
        <Show when={props.subtitle}>
          <p class="mx-auto max-w-[600px] font-rajdhani text-[15px] font-medium text-[var(--cf-muted)]">{props.subtitle}</p>
        </Show>
        {props.children}
      </div>
    </div>
  )
}
